import { useCallback, useRef } from 'react';

export const useStepVisibilityChange = (onFirstVisibleStepChange: (step: number) => void) => {
  const firstVisibleStepRef = useRef(-1);
  const visibleStepsRef = useRef<boolean[]>([]);

  return useCallback(
    (index: number, isVisible: boolean) => {
      visibleStepsRef.current[index] = isVisible;

      const firstVisibleIndex = visibleStepsRef.current.findIndex(visible => visible);

      if (firstVisibleIndex !== -1 && firstVisibleIndex !== firstVisibleStepRef.current) {
        firstVisibleStepRef.current = firstVisibleIndex;
        onFirstVisibleStepChange(firstVisibleIndex + 1);
      }
    },
    [onFirstVisibleStepChange],
  );
};
